{
  "assets": {
    "MapIcon": "Ikone",
    "Model": "3D-Modell",
    "none_selected_warning": "Sie müssen einen {{ assetType }} ausgewählt haben",
    "all_categories": "Alle Kategorien",
    "select": "Wählen Sie {{ assetType }}",
    "search_placeholder": "Suchen Sie nach {{ assetType }}"
  },
  "layerTemplates": {
    "selectTemplateText": "Suchen Sie nach Ebenenvorlagen",
    "createCustomLayer": "Erstellen Sie eine benutzerdefinierte Ebene",
    "startFromScratch": "eine neue Ebene von Grund auf neu erstellen",
    "failedToLoadTemplates": "Ebenenvorlagen konnten nicht geladen werden",
    "failedToLoadLayer": "Die Ebene konnte nicht geladen werden",
    "noLayerTemplates": "Wir können keine Vorlagen mit diesem Namen finden. Möchten Sie eine neue Ebene erstellen, ohne stattdessen eine Vorlage zu verwenden?",
    "searchPlaceholder": "ZB Transport",
    "allTemplates": "Alle Vorlagen",
    "searchResults": "Ergebnisse der Suche"
  },
  "toolbarButtonTooltips": {
    "draw_map_object": "Zeichnen",
    "undo": "Rückgängig machen",
    "redo": "Erneut",
    "copy_map_objects": "Kopieren/Einfügen",
    "draw_analysis_line": "Linie zeichnen",
    "draw_analysis_polygon": "Polygon zeichnen",
    "draw_rectangle": "Rechteck zeichnen",
    "draw_point": "Punkt zeichnen",
    "draw_icon": "Symbol zeichnen",
    "draw_model": "Modell zeichnen",
    "draw_line_model": "Linienmodell zeichnen",
    "snapping_tools": "Einstellungen für das Einrasten"
  },
  "sidebarButtonTooltips": {
    "new_layer": "Ebene aus Vorlage erstellen",
    "import_layer": "Importiert Ebene (n) aus anderen Plänen",
    "attribute_data_table": "Attributdatentabelle",
    "toggle_all_layers_visibility": "Schaltet die Sichtbarkeit aller Ebenen um",
    "hide_all_layers": "Verstecke alle Ebenen",
    "show_all_layers": "Alle Ebenen einblenden",
    "change_log": "Protokoll ändern"
  },
  "toggleAllLayersVisibilityConfirmation": {
    "title": "Schaltet die Sichtbarkeit aller Ebenen um",
    "message": "Dadurch wird die Sichtbarkeit aller Ebenen für alle Benutzer geändert. Sind Sie sicher, dass Sie fortfahren möchten?"
  },
  "layerOptionsTooltips": {
    "layer_information": "Informationen zur Ebene",
    "layer_view_options": "Optionen für die Ebenenansicht",
    "hide_layer": "Ebene ausblenden",
    "show_layer": "Ebene einblenden"
  },
  "backgroundMapSelector": {
    "background_map_options": "Optionen für den Hintergrund",
    "recommended": "Empfohlen",
    "configure": "Konfigurieren"
  },
  "sitemaps": {
    "no_sitemaps_available": "Keine Sitemaps an diesem Standort.\nSitemaps sind detaillierte Karten von Standorten, z. B. CAD-Zeichnungen, die den inneren Grundriss eines Gebäudes zeigen.",
    "no_sitemaps_available_2": "\num mehr über das Hinzufügen von Sitemaps zu erfahren"
  },
  "drawing_tooltips": {
    "title": "Werkzeuge zum Zeichnen",
    "enter_edit_mode": "Klicken Sie hier und dann auf die Karte, um mit dem Zeichnen zu beginnen",
    "enter_edit_mode_no_layers": "Um mit dem Zeichnen auf der Karte zu beginnen, erstellen Sie zunächst eine Ebene (oder wählen Sie sie aus), indem Sie das Feld auf der linken Seite verwenden",
    "enter_composition_part_1": "Klicken Sie auf die Karte, um Punkte hinzuzufügen. Doppelklicken oder drücken",
    "enter_composition_part_2": "um zu beenden."
  },
  "search_tooltip": {
    "set_save_title": "Diesen Standort als Standard für den Plan festlegen?",
    "set_save_content": "Der Plan kehrt an diesen Ort zurück, wenn Sie ihn das nächste Mal öffnen.",
    "set_save_save": "Ansicht speichern",
    "set_save_dismiss": "Vielleicht später",
    "save_info_title": "Gespeicherte Ansichten",
    "save_info_content": "Sie können gespeicherte Planansichten verwalten oder die Standardeinstellung für Ihren Plan über das Suchmenü ändern.",
    "save_info_got_it": "Ich hab's"
  },
  "attributes": {
    "allowed_metadata_properties": "Erlaubte Metadaten-Eigenschaften",
    "required": "Erforderlich",
    "system_datafield_type": "Typ des Systemdatenfeldes"
  },
  "map_tour": {
    "tip_3_location": {
      "title": "Finden Sie einen Standort",
      "content": "Hier können Sie nach Orten auf dem Plan suchen, z. B. nach Straßen, Orten oder Objekten, die Sie platziert haben. Du kannst auch wichtige Orte speichern, zu denen du springen kannst, und einen Standard für deinen Plan festlegen."
    },
    "tip_4_background": {
      "title": "Wähle deinen Kartenhintergrund",
      "content": "Hier können Sie aus verschiedenen Kartenhintergründen wählen, z. B. aus Satellitenbildern oder lokalen Kartenanbietern. Sie können auch den Standardhintergrund festlegen."
    },
    "tip_5_layer": {
      "title": "Erstelle deine erste Ebene",
      "content": "Um mit dem Zeichnen zu beginnen, erstellen Sie eine neue Ebene."
    }
  },
  "zoomableValues": {
    "fixed": "Behoben",
    "by_zoom_level": "Nach Zoomstufe",
    "edit_zoom_levels": "Zoomstufen bearbeiten",
    "predefined": "Vordefiniert",
    "custom": "Benutzerdefiniert",
    "hide": "Verstecken",
    "add_zoom_level": "Neue Zoomstufe hinzufügen",
    "zoom_options": "Zoom-Optionen",
    "zoom_levels": "Zoom-Stufen",
    "street_level": "Auf Straßenniveau",
    "city_level": "Auf Stadtebene",
    "country_level": "Auf Landesebene",
    "world_level": "Auf weltweiter Ebene",
    "max_level": "Auf maximaler Zoomstufe"
  },
  "sidebarToolbar": {
    "share": "Plan teilen"
  },
  "units": {
    "pixels": "Pixel",
    "degrees": "Abschlüsse",
    "scale": "Skala",
    "meters": "Meter"
  }
}